import React from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import { useHierarchicalMenu } from 'react-instantsearch';
import { HierarchicalMenuProps } from '@white-nl/instantsearch-components/dist/types/components';

interface HierarchicalMenuClassNames {
  root: string;
  noRefinementRoot: string;
  list: string;
  childList: string;
  item: string;
  selectedItem: string;
  parentItem: string;
  link: string;
  selectedItemLink: string;
  label: string;
  count: string;
  showMore: string;
  disabledShowMore: string;
}

type HierarchicalListProps = Pick<
  ReturnType<typeof useHierarchicalMenu>,
  'items'
> & {
  className?: string;
  classNames?: Partial<HierarchicalMenuClassNames>;
  createURL: (value: string) => string;
  onNavigate?: ((value: string) => void) | null;
};

function HierarchicalList({
  className = '',
  classNames = {},
  items,
  createURL,
  onNavigate = null,
}: HierarchicalListProps) {
  const listClass = [
    'ais-HierarchicalMenu-list',
    classNames.list,
    className,
  ].filter(Boolean).join(' ');

  let children = [] as typeof items;
  items.forEach((item) => {
    if (item.isRefined && item.data !== null) {
      children = item.data;
    }
  });

  return (
    <div className={classNames.root}>
      <ul className={listClass}>
        {children && children.length > 0 && children.map((child) => {
          const itemClass = [
            'group/link',
            classNames.item,
            child.isRefined ? 'active' : '',
          ].filter(Boolean).join(' ');

          return child.value && (
            <li
              key={child.value}
              className={itemClass}
            >
              <a
                className={classNames.link}
                href={createURL(child.value)}
                onClick={(event) => {
                  if (!onNavigate) {
                    return;
                  }
                  event.preventDefault();
                  onNavigate(child.value);
                }}
              >
                {child.label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default function HierarchicalMenu({
  menu,
  menuSettings,
  createURL: customCreateURL,
}: HierarchicalMenuProps) {
  const {
    classNames,
    hardRefresh,
  } = menuSettings;
  const {
    items,
    createURL,
    refine,
  } = menu;

  return (
    <HierarchicalList
      classNames={classNames}
      items={items}
      createURL={customCreateURL || createURL}
      onNavigate={hardRefresh ? null : refine}
    />
  );
}
